import { useMutation } from "@apollo/client/react";
import { Box, IconicButton } from "@nulogy/components";
import { GridBox4, StyledInput } from "components/common/EditableListStyledComponents";
import FieldRow from "components/common/FieldRow";
import Form from "components/controls/Form";
import { CreateDowntimeReason } from "hooks/apollo/downtimeReason/downtimeReason.gql";
import { insertDowntimeReason } from "hooks/apollo/downtimeReason/helpers/handleUpdateDowntimeReasons";
import React from "react";

export default function NewDowntimeReason({ downtimeReasonId, onRemoveNewDowntimeReason }) {
  const [createDowntimeReason] = useMutation(CreateDowntimeReason);

  const handleSave = ({ id, reason, code }) =>
    createDowntimeReason({
      update: (proxy, { data }) => {
        const newDowntimeReason = data.createDowntimeReason.downtimeReason;

        insertDowntimeReason(newDowntimeReason, proxy);
      },
      variables: { code, id, reason },
    });

  const removeNewDowntimeReason = () => {
    onRemoveNewDowntimeReason(downtimeReasonId);
  };

  return (
    <Form
      initialValues={{ code: "", id: downtimeReasonId, reason: "" }}
      onAfterSave={removeNewDowntimeReason}
      onSave={handleSave}
    >
      {({ dirty }) => (
        <FieldRow data-testid="new-downtime-reason-row" marginBottom="0">
          <GridBox4>
            <StyledInput field="reason" placeholder="Reason" />
            <StyledInput field="code" placeholder="Code" />
            <Box paddingTop="x1">
              <IconicButton disabled={!dirty} icon="check" type="submit">
                Save
              </IconicButton>
            </Box>
            <Box paddingTop="x1">
              <IconicButton icon="close" onClick={removeNewDowntimeReason} type="button">
                Cancel
              </IconicButton>
            </Box>
          </GridBox4>
        </FieldRow>
      )}
    </Form>
  );
}
